// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"16a0eb49","977":"34f10b19"}[chunkId] + ".chunk.js";
};